<template>
  <div class="loading-wrapper d-flex flex-column">
    <lottie-vue-player
      :src="`${publicPath}/img/rcp/loader.json`"
      :autoplay="true"
      :loop="true"
      style="max-width: 680px"
    ></lottie-vue-player>
    <div v-if="message" class="text-white fz-22 fw-400 text-center position-relative mt-4">{{ $t(message) }}</div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
    };
  },
  props:['message']
};
</script>

<style scoped>
.vue-lottie-player {
  background: unset !important;
}
</style>
